module.exports = __webpack_public_path__ + "img/ad_en3.6a7a9c4d.png";